import React from 'react';

function GuruCard({ guru, selected, onSelect, getAvatar }) {
  return (
    <div
      className={`guru-card ${selected ? 'selected' : ''}`}
      onClick={onSelect}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => { if (e.key === 'Enter') onSelect(); }}
    >
      <div className="guru-avatar-wrapper">
        <div className="guru-avatar">
          {guru.profile_image_url ? (
            <>
              <img
                src={guru.profile_image_url}
                alt={guru.name}
                className="guru-image"
                onLoad={(e) => {
                  e.target.classList.add('loaded');
                  const fallback = e.target.nextElementSibling;
                  if (fallback) fallback.classList.add('hidden');
                }}
                onError={(e) => {
                  e.target.classList.add('error');
                  const fallback = e.target.nextElementSibling;
                  if (fallback) fallback.classList.remove('hidden');
                }}
              />
              <span className="avatar-icon avatar-fallback">
                {getAvatar()}
              </span>
            </>
          ) : (
            <span className="avatar-icon">{getAvatar()}</span>
          )}
          <div className="avatar-ring"></div>
        </div>

        <div className="guru-rating">
          <div className="stars">
            {[...Array(5)].map((_, i) => (
              <span key={i} className="star" style={{ '--i': i }}>⭐</span>
            ))}
          </div>
        </div>
      </div>

      <div className="guru-info">
        <h4 className="guru-name">{guru.name}</h4>
        <p className="refer-subtitle">{guru.qualification}</p>

        <div className="guru-specialties">
          {guru.specialties && guru.specialties.slice(0, 3).map((specialty, idx) => (
            <span key={idx} className="cardsubtext"
            style={{
              padding:"5px", fontSize:"11px", color:"#ffd700"
            }}>
              <span className="tag-dot">
              {specialty}
              </span>
            </span>
          ))}
        </div>

        <div className="guru-languages">
          <svg className="globe-icon" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor">
            <circle cx="12" cy="12" r="10" strokeWidth="2" />
            <path d="M2 12h20M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" strokeWidth="2" />
          </svg>
          <span>{guru.languages && guru.languages.join(', ')}</span>
        </div>
      </div>

      {selected && (
        <div className="selected-indicator">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <circle cx="12" cy="12" r="10" fill="#FFD700" />
            <path d="M8 12l3 3l5-5" stroke="#000" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>
      )}
    </div>
  );
}

export default React.memo(GuruCard);
